import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { GlobalService } from 'app/global/global.service';
import { CustomerOnboardFlowService } from 'app/main/pages/customer-onboard-flow/customer-onboard-flow.service';
import { OnboardingFacade } from 'app/main/pages/customer-onboard-flow/store/onboarding/onboarding.facade';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})

export class TeamInvitationGuard implements CanActivate {
  constructor(
    private onboardingFacade: OnboardingFacade,
    private customerOnboardFlowService: CustomerOnboardFlowService,
    private router: Router,
    private globalService: GlobalService,
    private translocoService: TranslocoService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const token = route.paramMap.get('token');

    if (!token) {
      this.globalService.toastrError(this.translocoService.translate('team invite missing token error message (team invite guard) - Team invitation link is missing a token.'));
      return of(this.router.createUrlTree(['/login']));
    }

    // Always validate the token with the API first.
    return this.customerOnboardFlowService.checkTeamInviteToken(token).pipe(
      map((response: { first_name: string }) => {
        // If the API call is successful, unconditionally update the store with the name.
        if (response && response.first_name) {
          this.onboardingFacade.updateUserProfileField('firstName', response.first_name);
        }
        // Grant access.
        return true;
      }),
      catchError(() => {
        // If the API call fails, the token is invalid. Deny access.
        this.globalService.toastrError(this.translocoService.translate('team invite bad token error message (team invite guard) - Cannot invite team.'));
        return of(this.router.createUrlTree(['/login']));
      })
    );
  }
}